import Vue from 'vue'

const pathsToClient = (routerName) => {
    const routerNames = ['Demandas', 'CadastrarDemanda', 'DetalheDemanda', 'Clube', 'NovaSenha', 'Contratos', 'CadastrarContrato', 'DetalheContrato', 'Societario', 'ClienteSocietarioCaptable', 'ClienteSocietarioAdministracao', 'ClienteSocietarioAtoConstitutivo', 'DetalheContratoPortfolioAtivos', 'DetalheContratoPortfolioInativos', 'DetalheContratoDepartamentoAtivos', 'DetalheContratoDepartamentoInativos']
    return routerNames.includes(routerName)
}

const pathsByPermissions = (routerName, permissions) => {
    const permissionMapping = {
        'Marcas': 'read',
        'DetalheMarca': 'read',
        'CadastrarMarca': 'write'
    }

    const permissionKey = permissionMapping[routerName]
    return permissionKey ? permissions.brands?.[permissionKey] === true : false
}

const pathsToMainClient = ['Colaboradores', 'CadastrarColaborador', 'EditarColaborador', 'ColaboradorDetalheAbaInfo']

const handlePasswordChange = (to, next) => {
    const user = JSON.parse(localStorage.profile)
    if (to.name !== 'NovaSenha' && user.changedPassword === false) {
        next({ path: '/nova_senha' })
        return true
    }
    return false
}

const handleAuthenticatedUser = (to, next, permissions) => {
    if (permissions) {
        if (pathsByPermissions(to.name, permissions)) {
            next() // Liberar rota se estiver autorizado
        } else {
            next({ path: '/marcas' }) // Redirecionar para Marcas se não autorizado
        }
    } else if (pathsToClient(to.name)) {
        next() // Rota disponível para o cliente
    } else if (Vue.helpers.checkIsMainAccount() && pathsToMainClient.includes(to.name)) {
        next() // Rota principal disponível
    } else {
        next({ path: '/demandas' }) // Rota padrão para clientes não autorizados
    }
}

const beforeEnter = (to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)

    if (requiresAuth) {
        if (Vue.helpers.hasSessionToken()) {
            if (handlePasswordChange(to, next)) return // Verifica se a senha foi alterada

            const isEmployee = localStorage.isEmployee.toLowerCase() === 'true'

            if (isEmployee) {
                next() // Liberar rota se for colaborador
            } else {
                const currentUserCompany = JSON.parse(localStorage.currentUserCompany)
                const permissions = currentUserCompany?.client?.permissions
                handleAuthenticatedUser(to, next, permissions)
            }
        } else {
            next({ path: '/login' }) // Redirecionar para login se não autenticado
        }
    } else {
        if (Vue.helpers.hasSessionToken()) {
            if (handlePasswordChange(to, next)) return // Verifica se a senha foi alterada

            if (to.path === '/login') {
                next({ path: '/demandas' }) // Redirecionar para demandas se já estiver autenticado
            } else {
                next()
            }
        } else {
            next()
        }
    }
}

export default beforeEnter
